import React from 'react'
import { Outlet } from 'react-router-dom'
import NoSidebar from '../layouts/nosidebar'
import NoSidebar2 from '../layouts/nosidebar2'

const MicroCourseLayout = ({ children }) => {
  return (
    <>
      <NoSidebar2 children={children}>
        <Outlet />
      </NoSidebar2>
    </>
  )
}

export default MicroCourseLayout;